import cloneDeep from 'clone-deep'
import { useState } from 'react'
import { Modal } from 'stories/components'

import { CreditScoreTemplate } from './CreditScoreTemplate'
import { LoanApplicationSignTemplate } from './LoanApplicationSignTemplate'
import { defaultCreditScoreTemplate, defaultLoanApplicationSignTemplate } from './signTemplate.defaults'

type TemplateKind = 'sign' | 'credit'

type Props = {
  kind: TemplateKind
  value: Record<string, any> | undefined
  onClose: () => void
  onSave: (value: Record<string, any>) => void
}

const titles: Record<TemplateKind, string> = {
  sign: 'Acknowledgement & Sign Template',
  credit: 'Credit Score Template',
}

const fallback = (kind: TemplateKind, value?: Record<string, any>) => {
  if (value && Object.keys(value).length) return cloneDeep(value)
  return kind === 'sign' ? defaultLoanApplicationSignTemplate() : defaultCreditScoreTemplate()
}

export const TemplateContentModal = ({ kind, value, onClose, onSave }: Props) => {
  const [draft, setDraft] = useState<Record<string, any>>(() => fallback(kind, value))

  return (
    <Modal
      isOpen
      title={titles[kind]}
      titleOkay="Save"
      onClose={onClose}
      onOk={() => {
        onSave(draft)
        return true
      }}
    >
      <div className="w-[min(900px,90vw)] max-h-[70vh] overflow-y-auto pr-1">
        {kind === 'sign' ? (
          <LoanApplicationSignTemplate value={draft} onChange={setDraft} />
        ) : (
          <CreditScoreTemplate value={draft} onChange={setDraft} />
        )}
      </div>
    </Modal>
  )
}
